import React from 'react';
import PropTypes from 'prop-types';
import styles from './CustomShareChgComponent.module.css';
import upArrow from '../../../assets/SVGs/UpwardsIcon.svg';
import downArrow from '../../../assets/SVGs/DownwardsIcon.svg';
import { HYPEN } from '../../../constants/constant';

// Need to refactor and use CustomShareChgComponent in future
const CustomShareChgComponentNoUnit = (props) => {
	const value = isNaN(props?.value) ? 0 : parseFloat(props?.value);
	if (value === 0) {
		return HYPEN;
	}

	const renderClass =
		value >= 0
			? `${styles.positiveValue} ${styles.defaultValue}`
			: `${styles.negativeValue} ${styles.defaultValue}`;

	const arrow = value >= 0 ? upArrow : downArrow;
	const absValue = Number(Math.abs(value));

	const formattedValue = absValue.toLocaleString('en-US', {
		maximumFractionDigits: 3,
	});

	return (
		<div className={renderClass}>
			<img src={arrow} alt={'Arrow'} className={styles.arrow} />
			{formattedValue}%
		</div>
	);
};

CustomShareChgComponentNoUnit.propTypes = {
	value: PropTypes.any,
};

export default CustomShareChgComponentNoUnit;
